export const homeTourSteps = [{
  title: <h1>Welcome!</h1>,
  description: 'Welcome to Footsteps2Brilliance Central — your all-in-one teaching partner! ',
  cover: <img src="assets/tour/HomePage/welcome-cover.png" alt="Welcome toFootsteps2Brilliance Central" />
}, {
  title: 'Teacher Toolkits!',
  description: 'Explore ready-to-go lessons, games, and books designed to accelerate learning and keep students engaged.',
  target: () => document.querySelector('#grades-feature-grid'),
  placement: 'top',
  scrollIntoView: true
}, {
  title: 'Search',
  description: 'Looking for something specific? Use the search bar to instantly find the perfect book, game, or interactive lesson to match your teaching goals.',
  target: () => document.querySelector('#toolkits-search'),
  placement: 'bottom',
  scrollIntoView: true
}, {
  title: 'Alignments',
  description: 'We’ve done the planning for you! Alignments match our lessons and games directly to your district’s curriculum, so you can assign meaningful practice with confidence — no extra prep required.',
  target: () => document.querySelector('#alignments-landing-page'),
  placement: 'right'
}, {
  title: 'Student Courses',
  description: 'Students can jump right in with courses that build success on grade-level standards.',
  target: () => document.querySelector('#curriculum-section')
}, {
  title: 'Reports',
  description: 'As your students use the program, reports give you clear, actionable insights with recommendations tailored to each student’s proficiency.',
  target: () => document.querySelector('#reports-section-button'),
  placement: 'left'
}, {
  title: 'Class Management',
  description: 'Use Class Management to check your roster, print parent letters, and adjust student or parent accounts when needed.',
  target: () => document.querySelector('#class-management-button'),
  placement: 'left'
}, {
  title: 'MyF2B App',
  description: 'How do students connect? Students and families can keep learning anytime, anywhere with the MyF2B app or at myf2b.com.',
  cover: <img src="assets/tour/HomePage/new-app-cover.png" alt="MyF2B App" />
}, {
  title: 'Refresher',
  description: 'Want a quick reminder? Replay this tour anytime.',
  target: () => document.querySelector('#home-tour-button'),
  nextButtonProps: {
    children: 'Got it!'
  },
  placement: 'top'
}];